module.exports = __webpack_public_path__ + "static/media/green-tick.518c7c92.svg";